import { Flex, Link, Text } from '@chakra-ui/react';

import { WarningOutline as Warning } from '@aslanpay/portal-common-lib';

import { EmptyStateProps } from './types';

function EmptyState({
  full = true,
  text = 'There is no information to display',
  link,
  linkText,
}: EmptyStateProps) {
  return (
    <Flex
      w={full ? 'full' : 'auto'}
      mx={full ? 0 : 'auto'}
      flexDir="column"
      align="center"
      gap="20px"
      p="50px"
      bgColor="brand.lightGray2"
      border="1px solid"
      borderRadius="8px"
      borderColor="brand.lightGray1"
    >
      <Warning color="brand.mediumGray" boxSize="60px" />
      <Text as="h6" textStyle="h6Medium" color="brand.mutedPurple">
        {text}
      </Text>
      {link && linkText && (
        <Link href={link} color="brand.purple" textStyle="h6Medium">
          {linkText}
        </Link>
      )}
    </Flex>
  );
}

export default EmptyState;
